<script lang="ts">
  export let klass: string = "";
</script>

<td class={klass}>
  <slot />
</td>
